import { createApi } from '@reduxjs/toolkit/query/react';
import { BaseQueryWithReAuth } from '../utils';
import { energyAccountingEndpoints } from './endpoints';

export const energyAccountingBaseQuery = BaseQueryWithReAuth({
  baseUrl: `${import.meta.env.VITE_ANALYTICS_BASE_URL}/`,
  credentials: 'same-origin',
  setHeaders: (headers) => {
    headers.set(
      'Authorization',
      `Bearer ${localStorage.getItem('accessToken') || ''}`
    );
    return headers;
  }
});

const energyAccountingApi = createApi({
  reducerPath: 'energyAccountingApi',
  baseQuery: energyAccountingBaseQuery,
  endpoints: energyAccountingEndpoints
});

export const {
  usePrefetch,
  useGetHierarchyFiltersQuery,
  useGetNetWorkHierarchyDetailsQuery,
  useGetTotalEnergyMetricsQuery,
  useGetSubStationWiseListViewQuery,
  useGetFeederWiseListViewQuery,
  useGetDTWiseListViewQuery
} = energyAccountingApi;

export default energyAccountingApi;
